import Moment from 'moment'
import MenuGroupItem from "@/model/dailymenu/MenuGroupItem";
import _ from 'lodash'
import DailyMenuOption from '@/model/dailymenu/DailyMenuOption'
import i18n from "@/i18n";

export default class DailyReservationGroup {

  private constructor (
    readonly date: Date,
    readonly boarderGroup: any,
    readonly menuGroups: any,
    // readonly menuGroup: any,
    // readonly menuGroupSlot: any,
    // readonly activeCount: number,
    // readonly deliveredCount: number,
    // readonly notDeliveredCount: number,
    // readonly canceledCount: number,

  ) {}

  get dayName (): string {
    const date = Moment(this.date);
    date.locale(i18n.locale)
    return date.format("dddd")
  }

  get formatedDate (): string {
    const date = Moment(this.date);
    return date.format("D.M.Y")
  }
  //
  static createFromResponse (responseData: any): DailyReservationGroup {

      const date = responseData[0].date
      const boarderGroup = responseData[0].boarderGroup
      return new DailyReservationGroup(
        Moment(date).toDate(),
        boarderGroup,
        responseData
      )

  }
}
